import {AxiosError} from 'axios';
import dayjs from 'dayjs';

import {
    Completable,
    EmployeeEligibilityDTO,
    EmployeeSummaryDTO,
    KashableResponseDTO,
    PayrollGroupDTO,
    UnderwritingContext,
} from 'kashable-mobile-common';

import {errored, mapSucceeded} from '../utils/AxiosUtils';

import axios from './base';

const checkEligibility: (uec: UnderwritingContext) => Promise<Completable<EmployeeEligibilityDTO>> = (
    uec,
) => {
    return axios
        .get<KashableResponseDTO<EmployeeEligibilityDTO>>('/secured/user/eligibility', {params: {uec}})
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const getPayrollGroup: () => Promise<Completable<PayrollGroupDTO>> = () => {
    return axios
        .get<KashableResponseDTO<PayrollGroupDTO>>('/secured/user/payroll')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const updatePayrollGroup: (form: PayrollGroupDTO) => Promise<Completable<string>> = (
    form: PayrollGroupDTO,
) => {
    return axios
        .post<KashableResponseDTO<string>>('/secured/user/payroll', {
            payroll_frequency: form.payroll_frequency,
            sample_date: dayjs(form.sample_date).format('YYYYMMDD'),
        })
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const getEmployeeSummary: () => Promise<Completable<EmployeeSummaryDTO>> = () => {
    return axios
        .get<KashableResponseDTO<EmployeeSummaryDTO>>('/secured/user/employee')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

export {checkEligibility, getPayrollGroup, getEmployeeSummary, updatePayrollGroup};
